import { styled } from 'Theme'

export const StyledListExtraLeft = styled.div`
  flex: 0 1 auto;
  padding: ${({ theme }): string => theme.list.item.left.padding};
`
